import React from 'react';

function Orders() {
  return (
    <div className="p-4 bg-gray-100 rounded-lg">
      <div className="order-card p-4 border bg-white shadow rounded-lg">
        <h3 className="text-lg font-bold">Order #229977338001021611</h3>
        <p className="text-[#6B7280] text-sm">05 Nov 2024, GMT-08:00</p>
        <p className="mt-2">
          <b>14 inch Win 10/11 brand new notebook</b>
          <br />
          N4000 N3350 2.4Ghz DDR3 128GB ROM and HD screen laptop
          <br />
          <b>Order total:</b> USD 151.00
        </p>
        <ul className="order-status mt-4 text-sm">
          <li>✔ Send order request and confirm details</li>
          <li>✔ Supplier drafts order on Alibaba.com</li>
          <li>⏳ Complete payment by payment plan</li>
          <li>⏳ Supplier ships order</li>
          <li>⏳ Order delivered</li>
        </ul>
        <button className="mt-4 bg-blue500 text-white px-4 py-2 rounded-lg hover:bg-blue600">
          Make Payment
        </button>
      </div>
    </div>
  );
}

export default Orders;
